import React, {useState} from 'react';
import ItemsAvailable from "./itemsAvailable";
import MainButton from "../../commons/mainButton";

const AvailabilityPopup = ({rentUser, buttonHeight, premiumPalette, disabled}) => {
    const [open, setOpen] = useState(false);

    const styles = {
        container: {
            display: 'inline-block',
        },
        modalOverlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            zIndex: 1000,
        },
        modalBox: {
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            maxWidth: '90%',
            maxHeight: '90vh',
            overflowY: 'auto',
            width: '1200px',
        }
    };

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <div style={styles.container}>
            <MainButton text={'Verifica disponibilità'}
                        action={handleOpen}
                        disabled={disabled}
                        backgroundColor={premiumPalette.primaryColor}
                        height={buttonHeight}/>
            {open && (
                <div style={styles.modalOverlay} onClick={handleClose}>
                    <div style={{...styles.modalBox, backgroundColor: premiumPalette.primaryColorFourthAlternative}}
                         onClick={(e) => e.stopPropagation()}>
                        <ItemsAvailable rentUser={rentUser}
                                        premiumPalette={premiumPalette}/>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AvailabilityPopup;
